/** Signed-in user, workspace and role for the whole app; `can(min)` mirrors the API's RBAC. */
import { type Me, type Role, roleAtLeast } from "@brecx/shared";
import { createContext, type ReactNode, useContext } from "react";

export interface Session extends Me {
  csrf: string;
}

const Ctx = createContext<{ me: Session; refresh: () => void } | null>(null);

export function SessionProvider({
  me,
  refresh,
  children,
}: {
  me: Session;
  refresh: () => void;
  children: ReactNode;
}) {
  return <Ctx.Provider value={{ me, refresh }}>{children}</Ctx.Provider>;
}

export function useSession() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useSession outside SessionProvider");
  return { ...v, can: (min: Role) => roleAtLeast(v.me.role, min) };
}
